export const COMBINE_CONDITION_OPTIONS = {
  ANY: { label: "Or", id: "ANY" },
  ALL: { label: "And", id: "ALL" }
};

export const CONDITION_OPERATOR_OPTIONS = {
  IS: { label: "Is", id: "IS" },
  IS_NOT: { label: "Is not", id: "IS_NOT" },
  IS_IN: { label: "Is in", id: "IS_IN" },
  IS_NOT_IN: { label: "Is not in", id: "IS_NOT_IN" },
  CONTAINS: { label: "Contains", id: "CONTAINS" },
  NOT_CONTAINS: { label: "Doesn't contains", id: "NOT_CONTAINS" },
  START_WITH: { label: "Start with", id: "START_WITH" },
  END_WITH: { label: "End with", id: "END_WITH" },
  GT: { label: "Greater than", id: "GT" },
  LT: { label: "Less than", id: "LT" },
  GE: { label: "Greater than or equal to", id: "GE" },
  LE: { label: "Less than or equal to", id: "LE" },
  IS_BLANK: { label: "Is Blank", id: "IS_BLANK" },
  IS_DATE: { label: "Is", id: "IS_DATE" },
  IS_NOT_DATE: { label: "Is not", id: "IS_NOT_DATE" },
  BEFORE: { label: "Before", id: "BEFORE" },
  AFTER: { label: "After", id: "AFTER" },
  BE: { label: "Before or equal to", id: "BE" },
  AE: { label: "After or equal to", id: "AE" },
  BETWEEN: { label: "Between", id: "BETWEEN" },
  BETWEEN_DATE: { label: "Between", id: "BETWEEN_DATE" },
  HAS: { label: "Contains all", id: "HAS" },
  HAS_PARTIAL: { label: "Contains any", id: "HAS_PARTIAL" },
  HAS_NOT: { label: "Doesn't contains", id: "HAS_NOT" },
  DAY_IS: { label: "Day Is", id: "DAY_IS" },
  MONTH_IS: { label: "Month Is", id: "MONTH_IS" },
  YEAR_IS: { label: "Year Is", id: "YEAR_IS" },
  UPLOADED: {label: "Uploaded", id: "UPLOADED"},
  FILE_INFO_UPLOADED: {label: "Uploaded", id: "FILE_INFO_UPLOADED"}
};

export const CONDITION_DATE_OPERATOR_OPTIONS_LIST = [
  CONDITION_OPERATOR_OPTIONS.IS_DATE,
  CONDITION_OPERATOR_OPTIONS.IS_NOT_DATE,
  CONDITION_OPERATOR_OPTIONS.BEFORE,
  CONDITION_OPERATOR_OPTIONS.AFTER,
  CONDITION_OPERATOR_OPTIONS.BE,
  CONDITION_OPERATOR_OPTIONS.AE,
  CONDITION_OPERATOR_OPTIONS.BETWEEN_DATE,
  CONDITION_OPERATOR_OPTIONS.DAY_IS,
  CONDITION_OPERATOR_OPTIONS.MONTH_IS,
  CONDITION_OPERATOR_OPTIONS.YEAR_IS
];

export const CONDITION_SINGLE_SELECT_OPERATOR_OPTIONS_LIST = [
  CONDITION_OPERATOR_OPTIONS.IS,
  CONDITION_OPERATOR_OPTIONS.IS_NOT,
  CONDITION_OPERATOR_OPTIONS.IS_IN,
  CONDITION_OPERATOR_OPTIONS.IS_NOT_IN,
];

export const CONDITION_MULTI_SELECT_OPERATOR_OPTIONS_LIST = [
  CONDITION_OPERATOR_OPTIONS.HAS,
  CONDITION_OPERATOR_OPTIONS.HAS_PARTIAL,
  CONDITION_OPERATOR_OPTIONS.HAS_NOT
];

export const CONDITION_TEXT_OPERATOR_OPTIONS_LIST = [
  CONDITION_OPERATOR_OPTIONS.IS,
  CONDITION_OPERATOR_OPTIONS.IS_NOT,
  CONDITION_OPERATOR_OPTIONS.IS_IN,
  CONDITION_OPERATOR_OPTIONS.IS_NOT_IN,
  CONDITION_OPERATOR_OPTIONS.CONTAINS,
  CONDITION_OPERATOR_OPTIONS.NOT_CONTAINS,
  CONDITION_OPERATOR_OPTIONS.START_WITH,
  CONDITION_OPERATOR_OPTIONS.END_WITH,
  CONDITION_OPERATOR_OPTIONS.GT,
  CONDITION_OPERATOR_OPTIONS.GE,
  CONDITION_OPERATOR_OPTIONS.LT,
  CONDITION_OPERATOR_OPTIONS.LE,
  CONDITION_OPERATOR_OPTIONS.BETWEEN
];

export const CONDITION_OPERATOR_OPTIONS_BY_FIELD_TYPE = {
  DATE: CONDITION_DATE_OPERATOR_OPTIONS_LIST,
  SINGLE_SELECT: CONDITION_SINGLE_SELECT_OPERATOR_OPTIONS_LIST,
  MULTI_SELECT: CONDITION_MULTI_SELECT_OPERATOR_OPTIONS_LIST,
  DEFAULT: CONDITION_TEXT_OPERATOR_OPTIONS_LIST
};



// WEBPACK FOOTER //
// ./src/constants/condition-params.js